import './polyfill';

let config = {};

try {
  config = JSON.parse(process.env.ENVIRONMENT_VARIABLES || '');
} catch (error) {
  console.log('Error parsing environment variables');
}

const makeQuery = query => Object.keys(query).map(item => `${ item }=${ encodeURIComponent(query[item]) }`).join('&');

const registerIframeMessageHandler = (iframe, register) => {
  const IframeMessageHandler = event => {
    const { data } = event;
    try {
      // let message = JSON.parse(data);
      let message = data;
      if (
        message &&
        message.dimensions &&
        message.dimensions.height
      ) {
        const { dimensions } = message;
        if (dimensions) iframe.setAttribute('height', dimensions.height);
      }
    } catch (error) {
      throw error;
    }
  };
  if (register) {
    window.addEventListener('message', IframeMessageHandler, false);
  } else {
    window.removeEventListener('message', IframeMessageHandler);
  }
};

const injectIframe = (element, { base }) => {
  if (element) {
    // Gather properties from element
    let prop = 'data-widget-apostas-';
    let attributes = [ ...element.attributes ]
    .filter(item => item.name.includes(prop))
    .map(item => ({ [item.name.split(prop).join('').split('-').join('_')]: item.value }));
    // Generate iframe source
    let query = {};
    for (let attr of attributes) query = { ...query, ...attr };
    let uri = makeQuery(query);
    let url = `${ base }/${ uri ? '?' + uri : '' }`;
    // Create and append iframe
    const iframe = document.createElement('IFRAME');
    iframe.setAttribute('src', url);
    iframe.setAttribute('width', '100%');
    iframe.setAttribute('height', 0);
    iframe.setAttribute('frameborder', 0);
    element.appendChild(iframe);
    element.setAttribute('data-widget-apostas-initialized', true);
    // Size iframe based on message received
    registerIframeMessageHandler(iframe, true);
    iframe.addEventListener('DOMNodeRemoved', () => registerIframeMessageHandler(iframe, false), false);
  }
};

const base = config.inject;
const elements = document.querySelectorAll('[data-widget-apostas]');

for (let index = 0; index < elements.length; index++) {
  let element = elements[index];
  if (!element.hasAttribute('data-widget-apostas-initialized')) injectIframe(element, { base });
}
